import React from 'react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { offer } from '../data/offer';
export function Guarantee() {
  const days = offer.guaranteeDays;
  return <section className="bg-ivory px-5 py-14" data-id="element-107" data-mp="223y4543nw1ij">
      <Reveal data-id="element-108" data-mp="222n1j7lyczt0">
        <div className="flex flex-col items-center rounded-3xl border border-ivory-line bg-leaf-bg px-5 py-9 text-center" data-id="element-109" data-mp="221bvf151bfyq">
          <div className="flex h-36 w-36 items-center justify-center rounded-full border-4 border-wood bg-espresso p-2 shadow-soft" data-id="element-110" data-mp="19ehf8gf932r2">
            <div className="flex h-full w-full flex-col items-center justify-center rounded-full border border-dashed border-wood/60" data-id="element-111" data-mp="14gph34o0ikef">
              <span className="font-display text-5xl leading-none text-wood" data-id="element-112" data-mp="1j6n7zsdbto7b">{days}</span>
              <span className="mt-1 font-display text-base uppercase tracking-widest text-ivory" data-id="element-113" data-mp="1ecizh4oex844">Giorni</span>
            </div>
          </div>
          <h3 className="mt-6 font-display text-[30px] uppercase leading-[1.02] text-ink" data-id="element-114" data-mp="lpogydb5oita">
            Garanzia soddisfatti o rimborsati di {days} giorni
          </h3>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-body" data-id="element-115" data-mp="oxp1w1u3950d">
            Prova il pack per {days} giorni con la tua classe. Se non ti fa risparmiare ore di preparazione,
            scrivici una semplice email e ti rimborsiamo per intero. Senza domande.
          </p>
        </div>
      </Reveal>
      <InlineCta label="Provalo senza rischi" data-id="element-116" data-mp="12sr70mr42qc4" />
    </section>;
}